import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PoHeaderComponent } from './layout/po-header/po-header.component';
import { LayoutComponent } from './layout/layout.component';
import { SigninComponent } from './signin/signin.component';
import { CreatepurchaseComponent } from './layout/createpurchase/createpurchase.component';
import { DashboardComponent } from './layout/dashboard/dashboard.component';
import { PaymentinfoComponent } from './layout/paymentinfo/paymentinfo.component';
import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { SalescreditNoteComponent } from './layout/salescredit-note/salescredit-note.component';
import { NotificationListComponent } from './layout/notification-list/notification-list.component';
import { NotificationsComponent } from './layout/notifications/notifications.component';
import { ViewNotificationComponent } from './layout/view-notification/view-notification.component';
import { TdsCertificateComponent } from './layout/tds-certificate/tds-certificate.component';


const routes: Routes = [

  {
    path: 'createpurchaseorder', component: LayoutComponent,
    children: [{ path: '', component: CreatepurchaseComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboard', component: LayoutComponent,
    children: [{ path: '', component: DashboardComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: 'poheader', component: LayoutComponent,
    children: [{ path: '', component: PoHeaderComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: 'paymentinformation', component: LayoutComponent,
    children: [{ path: '', component: PaymentinfoComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: 'salescreditnote', component: LayoutComponent,
    children: [{ path: '', component: SalescreditNoteComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: 'notification', component: LayoutComponent,
    children: [{ path: '', component: NotificationsComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: 'notification-list', component: LayoutComponent,
    children: [{ path: '', component: NotificationListComponent }],
    canActivate: [AuthGuard]
  },
  {
    path: 'notification-details', component: LayoutComponent,
    children: [{ path: '', component: ViewNotificationComponent }],
    canActivate: [AuthGuard]
  },  
  {
    path: 'tds', component: LayoutComponent,
    children: [{ path: '', component: TdsCertificateComponent }],
    canActivate: [AuthGuard]
  },  
  {
    path: '**', component: SigninComponent,

  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
